import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect, useState } from "react";
import { $getRoot } from "lexical";

export const ClearEditorContents = ({ isClearEditor, setIsClearEditor }) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    if (!isClearEditor) return;

    editor.update(() => {
      $getRoot().clear();
    });
    setIsClearEditor(false);
  }, [isClearEditor]);
  return null;
};
